export default "__VITE_ASSET__d27c01bf__"